import axiosInstance from '../api/axios';


// Function to get all students
export const getAllLectureLinks = async () => {
    try {
        var id=-1;
        const response = await axiosInstance.get(`/getLectureLinks`);
        return response.data;
    } catch (error) {
        console.error('Error fetching lectures:', error);
        throw error;
    }
};